import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import VerticalTimeline from 'Components/ReactVerticalTimeline/VerticalTimeline';
import VerticalTimelineElement from 'Components/ReactVerticalTimeline/VerticalTimelineElement';
import TimelineNotepadIcon from 'Components/icons/TimelineNotepadIcon';
import TimelineDocumentIcon from 'Components/icons/TimelineDocumentIcon';
import TimelineStageIcon from 'Components/icons/TimelineStageIcon';
import TimelinePointIcon from 'Components/icons/TimelinePointIcon';
import TimelineMerchantIcon from 'Components/icons/TimelineMerchantIcon';
import TimelineNoteIcon from 'Components/icons/TimelineNoteIcon';
import TimelineRespondIcon from 'Components/icons/TimelineRespondIcon';
import TimelineSentToIssuerIcon from 'Components/icons/TimelineSentToIssuerIcon';
import TimelineDisputeReminderIcon from 'Components/icons/TimelineDisputeReminderIcon';
import TimelineDisputeNotificationIcon from 'Components/icons/TimelineDisputeNotificationIcon';
import TimelineTransactionIcon from 'Components/icons/TimelineTransactionIcon';
import TimelineStatusIcon from 'Components/icons/TimelineStatusIcon';
import TimelineTransferCaseIcon from 'Components/icons/TimelineTransferCaseIcon/TimelineTransferCaseIcon.jsx';
import BVLoader from 'Components/loaders/BVLoader/BVLoader20';
import TimelineHeader from './TimelineHeader';
import TimelineAccordion from './TimelineAccordion';
import TimelineMerchant from './TimelineMerchant';
import TimelineTransaction from './TimelineTransaction';
import TimelineCaseCreated from './TimelineCaseCreated';
import TimelineDocument from './TimelineDocument';
import TimelineStageCard from './TimelineStageCard';
import TimelineCard from './v2/TimelineCard';
import TimelineAcceptLiability from 'Components/icons/TimelineAcceptLiability/TimelineAcceptLiability.jsx';
import TimelineRejectCase from 'Components/icons/TimelineRejectCase';
import TimelineMerchantDeny from 'Components/icons/TimelineMerchantDeny/TimelineMerchantDeny.jsx';
import TimelineChallengeIcon from 'Components/icons/TimelineChallengeIcon/TimelineChallengeIcon.jsx';
import TimelineMerchantUnableToFulfill from 'Components/icons/TimelineMerchantUnableToFulfill/TimelineMerchantUnableToFulfill.jsx';
import TimelinemMerchantFulfill from 'Components/icons/TimelinemMerchantFulfill/TimelinemMerchantFulfill.jsx';
import './vertical-style.scss';
import { isEmpty } from 'Utils/lodashUtils';
import { COLORS } from "Constants/BIDashboardConstants";

const TimeLine = (props) => {
  const [displayItems, setDisplayItems] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [sorted, setSorted] = useState(false);

  const updateStageMap = (id) => {
    props.updateMap(id);
  };

  useEffect(() => {
    setDisplayItems(props.displayData);
    setSorted(props.dataSort);
  }, [props.dataSort, props.displayData]);

  const renderIcon = (caseAction, fill) => {
    switch (caseAction) {
      case 'UNRESOLVE_RTI':
        return (
          <TimelineNoteIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'CREATE_DOCUMENT':
        return (
          <TimelineDocumentIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'DOCUMENT_LINKING':
        return (
          <TimelineDocumentIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'DOCUMENT_ATTACHED':
      case 'SUMMARY_DOCUMENT_ATTACHED':
        return (
          <TimelineDocumentIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
        case 'CREDIT_DOC_ATTACHED':
        return (
          <TimelineDocumentIcon fill={`${COLORS.oneGp.globalBlue}`} />
          );
          case 'REVERSAL_DOC_ATTACHED':
          return (
            <TimelineDocumentIcon fill={`${COLORS.oneGp.globalBlue}`} />
            );
      case 'DOCUMENT_UNLINKING':
        return (
          <TimelineDocumentIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'MERCHANT_ADDED':
        return (
          <TimelineMerchantIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'MERCHANT_MATCHED':
        return (
          <TimelineMerchantIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'CRTE_NEW_ADMIN':
        return (
          <TimelineMerchantIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'TRANSACTION_ATTACHED':
        return (
          <TimelineTransactionIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'TRANS_MATCH_MANUAL':
        return (
          <TimelineTransactionIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'CASE_NOTE':
        return (
          <TimelineNoteIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'STAGE_UPDATED':
        return (
          <TimelineStageIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'NEW_CASE_STAGE':
        return (
          <TimelineStageIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'TRANS_MATCH_AUTOMATIC':
        return (
          <TimelineStageIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'CHANGED_STATUS':
        return (
          <TimelineStatusIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'RESPONDED':
        return (
          <TimelineRespondIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'TRANSFER_CASE':
        return (
          <span className="transfer-case-view">  <TimelineTransferCaseIcon fill={`${COLORS.oneGp.globalBlue}`} padding={25} /></span>
        ); 
      case 'MERCHANT_ACCEPT_LIABILITY':
        return (
          <TimelineAcceptLiability fill={`${COLORS.oneGp.globalBlue}`} />
        ); 
      case 'MERCHANT_REJECTED_CASE':
          return (
            <TimelineRejectCase fill={`${COLORS.oneGp.globalBlue}`} />
          );     
      case 'MERCHANT_DENY':
        return (
          <TimelineMerchantDeny fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'CHALLENGE':
        return (
          <TimelineChallengeIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'FULFILL_REQUEST':
        return (
          <TimelinemMerchantFulfill fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'MERCH_UNABLE_TO_FULFILL':
      case 'UNABLE_TO_FULFILL':
        return (
          <TimelineMerchantUnableToFulfill fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'RESPONSE_TO_ISSUER':
      case 'RESPOND_TO_CARD_BRAND':
        return (
          <TimelineSentToIssuerIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'REQUEST_ADDITIONAL_INFO':
        return (
          <TimelineDisputeReminderIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'NOTIFY_AND_REQUEST_DOCS':
      case 'UNABLE_TO_DEFEND':
      case 'WRITE_OFF_GOODWILL':
      case 'CLOSED_CASE':
      case 'MANUALLY_PROCESSED':
      case 'ISSUER_DOC_REQUEST_EVENT':  
        return (
          <TimelineDisputeNotificationIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'DECISION_WON':
      case 'DECISION_PARTIAL':
      case 'DECISION_LOST':
      case 'CONFIRMATION_ACCEPTED':
      case 'CONFIRMATION_REJECTED':
      case 'CB_API_RES_ACK':
      case 'RULING_WON':
      case 'RULING_LOST':
      case 'CONFIRMATION_NOT_EXPECTED':
      case 'DECISION_NOT_EXPECTED':
        return (
          <TimelineDisputeNotificationIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
      case 'STAGE_CLOSE':
          return (
            <TimelineStageIcon fill={`${COLORS.oneGp.globalBlue}`} />
          );
      default:
        // eslint-disable-next-line consistent-return
        return (
          <TimelineNotepadIcon fill={`${COLORS.oneGp.globalBlue}`} />
        );
    }
  };
  const categories = () => displayItems.map((listItem, index) => {
    const {
      eventHeaderDetails,
      caseStageId,
    } = listItem;
    const configEventCode = ['DECISION_WON', 'DECISION_PARTIAL', 'DECISION_LOST', 'CONFIRMATION_ACCEPTED', 'CONFIRMATION_REJECTED', 'RULING_WON', 'RULING_LOST', 'CONFIRMATION_NOT_EXPECTED', 'DECISION_NOT_EXPECTED'].includes(listItem.eventHeaderDetails.eventCode) ? 'CONFIRMATION_DECISIONS' : listItem.eventHeaderDetails.eventCode;
    const side = configEventCode === ('CONFIRMATION_DECISIONS' || configEventCode === 'CB_API_RES_ACK') ? 'left' : 'right';
    const fill = side === 'left' ? 'grey' : '#583b7e';
    const stageElement = listItem.stageElement && listItem.stageElement === true;
    let timelineActionsV2 = ['CHALLENGE','PURSUE_CASE_FILING','MERCHANT_ACCEPT_LIABILITY','MERCHANT_REJECTED_CASE','FULFILL_REQUEST','MERCHANT_DENY','UNABLE_TO_FULFILL','MERCH_UNABLE_TO_FULFILL','MERCHANT_CASE_NOTE_ADDED','DOCUMENT_LINKING','UPLOAD_DOCUMENT','DOCUMENT_ATTACHED','CREDIT_DOC_ATTACHED','REVERSAL_DOC_ATTACHED','NOTIFY_AND_REQUEST_DOCS', 'REQUEST_ADDITIONAL_INFO', 'CASE_NOTE', 'EXTERNAL_CASE_NOTE', 'RESPONSE_TO_ISSUER', 'UNABLE_TO_DEFEND', 'WRITE_OFF_GOODWILL', 'CASE_CLOSE', 'RESPOND_TO_CARD_BRAND', 'CREATE_DOCUMENT', 'UNRESOLVE_RTI', 'MANUALLY_PROCESSED', 'SUMMARY_DOCUMENT_ATTACHED', 'ISSUER_DOC_REQUEST_EVENT'];
    const decisionCardStatus = ['DECISION_WON', 'DECISION_PARTIAL', 'DECISION_LOST', 'CONFIRMATION_ACCEPTED', 'CONFIRMATION_REJECTED','ADDITIONAL_INFORMATION','RULING_WON','RULING_LOST' , 'CONFIRMATION_NOT_EXPECTED', 'DECISION_NOT_EXPECTED'];
    props.cardBrandCode=='MC' && decisionCardStatus.push('CB_API_RES_ACK');
    timelineActionsV2 = !props.isMerchantUser ? [...timelineActionsV2 , ...decisionCardStatus] : timelineActionsV2;
    const timelineActionsV2SplitterCards = ['AUTH_MATCHED', 'TRANS_MATCHED','CREDIT_TRANS','REFERENCE_TRANS'];
    const isNewStage = eventHeaderDetails.eventCode === 'NEW_CASE_STAGE';
    const isAddInfo = eventHeaderDetails.eventCode === 'ADDITIONAL_INFORMATION';
    const isStageClose = eventHeaderDetails.eventCode === 'STAGE_CLOSE';


    //const key = stageElement ? `${caseStageId}${disputeStageName}` : eventHeaderDetails.eventId;
    const transactionActions = ['TRANSACTION_ATTACHED', 'TRANS_MATCH_MANUAL'];
    const merchantActions = ['MERCHANT_ADDED', 'MERCHANT_MATCHED'];
    const statusActions = ['TRANSFER_CASE'];//'CHANGED_STATUS', 'CRTE_NEW_ADMIN'];
    const documentActions = ['DOCUMENT_LINKING', 'DOCUMENT_UNLINKING','DOCUMENT_ATTACHED','CREDIT_DOC_ATTACHED','REVERSAL_DOC_ATTACHED','CREATE_DOCUMENT','UNRESOLVE_RTI', 'SUMMARY_DOCUMENT_ATTACHED'];
    const stageActions = ['NEW_CASE_STAGE','STAGE_CLOSE'];//'STAGE_UPDATED'


    const timelineElement = !listItem.stageElement && !isEmpty(props.stageMap) && props.stageMap[caseStageId] && props.stageMap[caseStageId].isOpen && stageActions.includes(listItem.eventHeaderDetails.eventCode) || timelineActionsV2.includes(listItem.eventHeaderDetails.eventCode) || statusActions.includes(listItem.eventHeaderDetails.eventCode) || timelineActionsV2SplitterCards.includes(listItem.eventHeaderDetails.eventCode);
     let filterdList = [].concat(listItem.eventBodyDetails);
     const displayHeader = filterdList.length > 0 && filterdList.filter((item) => {
      if (props.filterSet.includes(item.sectionCode)) {
         return true
      }  return false  
    }); 

    const isHeaderDisplay = displayHeader.length > 0 ? true : false;
    return (
      <div key={index}>
        {stageElement
          && (
            <TimelineAccordion
              listItem={listItem}
              id={caseStageId}
              isOpen={props.stageMap[caseStageId]?.isOpen}
              toggleAccordion={updateStageMap}
              renderIcon={renderIcon}
              fill={props.isMerchantUser ? '#007dc3' : '#3A3D46'}
              fetchImages={props.fetchImages}
              toggleDrawer={props.toggleDrawer}
              getApiDrawerData={props.getApiDrawerData}
              configId={props.configId}
              isMerchantUser={props.isMerchantUser}
              dateFormat={props.dateFormat}
              timeFormat={props.timeFormat}
              getCaseDetails={props.getCaseDetails}
              caseNumber={props.caseNumber}
              getFetchCaseLoader={props.getFetchCaseLoader}
              setActiveStageIndicatorSettingsOpenFlag={props.setActiveStageIndicatorSettingsOpenFlag}
            />
          )
        }
        {timelineElement
          && props.stageMap[caseStageId] && props.stageMap[listItem.caseStageId].isOpen && listItem.eventBodyDetails.length > 0 &&  ((isHeaderDisplay && !isNewStage) || props.filterSet.includes('All')) && ((isHeaderDisplay && !isStageClose) || props.filterSet.includes('All')) && (
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              iconStyle={{
                background: 'transparent',
                width: '13px',
                height: '13px',
                borderRadius: '50%',
                boxShadow: 'none',
              }}
              position={side}
            >
              {((isHeaderDisplay && !isNewStage) || props.filterSet.includes('All')) && ((isHeaderDisplay && !isStageClose) || props.filterSet.includes('All')) && listItem.eventHeaderDetails.eventCode && listItem.eventBodyDetails.length > 0 && !timelineActionsV2SplitterCards.includes(listItem.eventHeaderDetails.eventCode) &&  
              <TimelineHeader
                side={side}
                fill={fill}
                listItem={listItem}
                renderIcon={renderIcon}
                isMerchantUser={props.isMerchantUser}
                dateFormat={props.dateFormat}
                timeFormat={props.timeFormat}
              >
                {/* {noteActions.includes(listItem.eventHeaderDetails.eventCode) && <TimelineNote listItem={listItem} />} */}
                {props.filterSet.includes('All') && merchantActions.includes(listItem.eventHeaderDetails.eventCode) && <TimelineMerchant listItem={listItem} />}
                {props.filterSet.includes('All') && transactionActions.includes(listItem.eventHeaderDetails.eventCode) && <TimelineTransaction listItem={listItem} fill="#007dc3" />}
                {props.filterSet.includes('All') && !isHeaderDisplay && stageActions.includes(listItem.eventHeaderDetails.eventCode) && <TimelineCard cardBrandCode={props.cardBrandCode} historyData={props.historyData} isNewStage={isNewStage} configEventCode={configEventCode} eventCode={listItem.eventHeaderDetails.eventCode} listItem={listItem} filterSet={props.filterSet} isMerchantUser={props.isMerchantUser} dateFormat={props.dateFormat} timeFormat={props.timeFormat} isAddInfo = {isAddInfo} getApiDrawerData={props.getApiDrawerData} toggleDrawer = {props.toggleDrawer} isArchival={props.isArchival} isStageClose={isStageClose}/>}
                {timelineActionsV2.includes(listItem.eventHeaderDetails.eventCode) && <TimelineCard cardBrandCode={props.cardBrandCode} historyData={props.historyData} isNewStage={isNewStage} listItem={listItem} configEventCode={configEventCode} caseNumber={props.caseNumber} callUnlinkBanner={props.callUnlinkBanner} filterSet={props.filterSet} isMerchantUser={props.isMerchantUser} dateFormat={props.dateFormat} timeFormat={props.timeFormat} isAddInfo = {isAddInfo} getApiDrawerData={props.getApiDrawerData} toggleDrawer = {props.toggleDrawer} isArchival={props.isArchival} isStageClose={isStageClose}/>}
                {(isHeaderDisplay || props.filterSet.includes('All')) && statusActions.includes(listItem.eventHeaderDetails.eventCode) && <TimelineCard cardBrandCode={props.cardBrandCode} historyData={props.historyData} isNewStage={isNewStage} listItem={listItem} configEventCode={configEventCode} caseNumber={props.caseNumber} callUnlinkBanner={props.callUnlinkBanner} filterSet={props.filterSet} isMerchantUser={props.isMerchantUser} dateFormat={props.dateFormat} timeFormat={props.timeFormat} isAddInfo = {isAddInfo} getApiDrawerData={props.getApiDrawerData} toggleDrawer = {props.toggleDrawer} isArchival={props.isArchival} isStageClose={isStageClose}/>}
                {props.filterSet.includes('All') && listItem.eventHeaderDetails.eventCode === 'NEW_CASE' && <TimelineCaseCreated listItem={listItem} />}
                {props.filterSet.includes('All') && documentActions.includes(listItem.eventHeaderDetails.eventCode) && <TimelineDocument
                  isReadOnly={props.isReadOnly} listItem={listItem} callUnlinkBanner={props.callUnlinkBanner} isMerchantUser={props.isMerchantUser} dateFormat={props.dateFormat} isArchival={props.isArchival}/>}
              </TimelineHeader>}
              {
              props.filterSet.includes('All') && timelineActionsV2SplitterCards.includes(listItem.eventHeaderDetails.eventCode) && (isHeaderDisplay || props.filterSet.includes('All'))
              && <TimelineHeader
                side={side}
                fill={fill}
                listItem={listItem}
                renderIcon={renderIcon}
                toggleDrawer={props.toggleDrawer}
                getApiDrawerData={props.getApiDrawerData}
                configId={props.configId}
                id={caseStageId}
                isMerchantUser={props.isMerchantUser}
                dateFormat={props.dateFormat}
                timeFormat={props.timeFormat}
              />
            }
            </VerticalTimelineElement>
          )
        }
      </div>
    );
  });

  return (
    <div className="timeline-con">
      {displayItems.length > 0 && Object.keys(props.stageMap).length > 0 && (
        <VerticalTimeline>
          {categories()}
        </VerticalTimeline>
      )}
      {displayItems.length === 0 && Object.keys(props.stageMap).length > 0 && (
        <BVLoader width="30px" fill="#583b7e" />
      )}
    </div>
  );
};

TimeLine.propTypes = {
  displayData: PropTypes.array,
  dataSort: PropTypes.bool,
  fetchImages: PropTypes.func,
  stageMap: PropTypes.object,
  callUnlinkBanner: PropTypes.func,
  updateMap: PropTypes.func,
  isReadOnly: PropTypes.bool,
  getAuthData: PropTypes.func,
  getTranData: PropTypes.func,
  getCreditTranData : PropTypes.func,
  getCaseData: PropTypes.func,
  getSchemeData: PropTypes.func,
  isArchival: PropTypes.bool,
};

TimeLine.defaultProps = {
  callUnlinkBanner: () => { },
  displayData: [],
  dataSort: false,
  fetchImages: () => { },
  stageMap: {},
  updateMap: () => { },
  getAuthData: () => { },
  getTranData: () => { },
  getCreditTranData: () => { },
  getCaseData: () => { },
  getSchemeData: () => { },
  isArchival: false,
};

export default TimeLine;
